(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class YGGalleryButton extends HTMLElement {
    connectedCallback() {
      if (this.isInitialized) {
        return;
      }

      this.isInitialized = true;
      this.gallery = this.closest('.product-gallery');
      this.carousel = this.gallery?.querySelector('media-carousel');
      this.leftButton = this.querySelector('.yg-left-button');
      this.rightButton = this.querySelector('.yg-right-button');
      this.handlePrevious = this.handlePrevious.bind(this);
      this.handleNext = this.handleNext.bind(this);
      this.updateButtonState = this.updateButtonState.bind(this);

      this.leftButton?.addEventListener('click', this.handlePrevious);
      this.rightButton?.addEventListener('click', this.handleNext);
      this.gallery?.addEventListener('carousel:change', this.updateButtonState);
      this.gallery?.addEventListener('carousel:settle', this.updateButtonState);
      this.updateButtonState();
    }

    disconnectedCallback() {
      this.leftButton?.removeEventListener('click', this.handlePrevious);
      this.rightButton?.removeEventListener('click', this.handleNext);
      this.gallery?.removeEventListener('carousel:change', this.updateButtonState);
      this.gallery?.removeEventListener('carousel:settle', this.updateButtonState);
    }

    handlePrevious(event) {
      event.preventDefault();
      event.stopPropagation();
      this.carousel?.previous?.();
    }

    handleNext(event) {
      event.preventDefault();
      event.stopPropagation();
      this.carousel?.next?.();
    }

    updateButtonState(event) {
      const visibleItems = this.getVisibleItems();
      const selectedSlide = event?.detail?.slide || this.carousel?.selectedSlide || visibleItems[0];
      const selectedIndex = visibleItems.indexOf(selectedSlide);
      const isFirst = selectedIndex <= 0;
      const isLast = selectedIndex >= visibleItems.length - 1;
      const hasMultipleItems = visibleItems.length > 1;

      this.leftButton?.toggleAttribute('disabled', !hasMultipleItems || isFirst);
      this.rightButton?.toggleAttribute('disabled', !hasMultipleItems || isLast);
    }

    getVisibleItems() {
      if (this.carousel?.visibleItems?.length) {
        return this.carousel.visibleItems;
      }

      return Array.from(this.carousel?.querySelectorAll('.product-gallery__media:not([hidden])') || []);
    }
  }

  class YGProductMediaTabs extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.handleCarouselChange = this.handleCarouselChange.bind(this);
      this.handleVariantChange = this.handleVariantChange.bind(this);
      this.addEventListener('click', this.handleClick);
      this.addEventListener('carousel:change', this.handleCarouselChange);
      this.addEventListener('carousel:settle', this.handleCarouselChange);

      const formId = this.closest('product-rerender')?.getAttribute('observe-form');
      this.form = formId ? document.getElementById(formId) || document.forms[formId] : null;
      this.form?.addEventListener('variant:change', this.handleVariantChange);
      this.setActiveImageEntry(0);

      if (!this.querySelector('.yg-product-gallery.active')) {
        const firstGallery = this.querySelector('.yg-product-gallery');

        if (firstGallery?.classList.contains('yg-model-gallery')) {
          this.activateGallery('model');
        } else if (firstGallery?.classList.contains('yg-video-gallery')) {
          this.activateGallery('video');
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('carousel:change', this.handleCarouselChange);
      this.removeEventListener('carousel:settle', this.handleCarouselChange);
      this.form?.removeEventListener('variant:change', this.handleVariantChange);
    }

    handleClick(event) {
      const imageEntry = event.target.closest('.yg-media-image-entry');

      if (imageEntry && this.contains(imageEntry)) {
        const targetIndex = Number(imageEntry.dataset.targetIndex || 0);

        this.pauseGalleryMedia();
        this.activateGallery('image');
        this.selectGalleryIndex(this.querySelector('.yg-image-gallery'), targetIndex);
        this.setActiveImageEntry(targetIndex);
        return;
      }

      const tab = event.target.closest('.yg-media-tab');

      if (!tab || !this.contains(tab)) {
        return;
      }

      const target = tab.dataset.galleryTarget;

      if (!target) {
        return;
      }

      this.pauseGalleryMedia();
      this.activateGallery(target);
    }

    handleVariantChange(event) {
      const variant = event.detail?.variant;

      if (!variant?.featured_media) {
        return;
      }

      const imageGallery = this.querySelector('.yg-image-gallery');
      const mediaItems = Array.from(imageGallery?.querySelectorAll('.product-gallery__media') || []);
      const mediaIndex = mediaItems.findIndex((item) => String(item.dataset.mediaId) === String(variant.featured_media.id));

      if (mediaIndex >= 0) {
        this.activateGallery('image');
        this.selectGalleryIndex(imageGallery, mediaIndex);
        this.setActiveImageEntry(mediaIndex);
      }
    }

    handleCarouselChange(event) {
      const imageGallery = event.target.closest('.yg-image-gallery');

      if (!imageGallery || !this.contains(imageGallery)) {
        return;
      }

      const mediaIndex = this.getImageMediaIndex(imageGallery, event.detail?.slide, event.detail?.index);

      if (mediaIndex >= 0) {
        this.setActiveImageEntry(mediaIndex);
      }
    }

    activateGallery(target) {
      this.querySelectorAll('.yg-product-gallery').forEach((gallery) => {
        gallery.classList.toggle('active', gallery.classList.contains(`yg-${target}-gallery`));
      });

      this.querySelectorAll('.yg-media-tab').forEach((tab) => {
        tab.classList.toggle('active', tab.dataset.galleryTarget === target);
      });

      if (target === 'model') {
        const modelMedia = this.querySelector('.yg-model-gallery model-media');
        modelMedia?.play?.();
      }
    }

    selectGalleryIndex(gallery, index) {
      const carousel = gallery?.querySelector('media-carousel');
      const activeDots = gallery?.querySelectorAll('.page-dots .tap-area.active') || [];
      const targetDot = activeDots[index] || activeDots[0];

      if (carousel?.select) {
        carousel.select(index, { animate: true });
      } else {
        targetDot?.click();
      }
    }

    setActiveImageEntry(targetIndex) {
      this.querySelectorAll('.yg-media-image-entry').forEach((entry) => {
        const entryIndex = Number(entry.dataset.targetIndex || 0);
        const isMoreEntry = entry.classList.contains('yg-media-image-entry-more');

        entry.classList.toggle('active', isMoreEntry ? targetIndex >= entryIndex : entryIndex === targetIndex);
      });

      this.updateImageEntryCount(targetIndex);
    }

    updateImageEntryCount(targetIndex) {
      const imageEntryList = this.querySelector('.yg-media-image-entry-list');
      const countElement = this.querySelector('.yg-media-image-entry-count');

      if (!imageEntryList || !countElement) {
        return;
      }

      const mediaTotal = Number(imageEntryList.dataset.mediaTotal || 0);
      const visibleEntryCount = this.querySelectorAll('.yg-media-image-entry').length;
      const visibleImageCount = Math.min(visibleEntryCount, mediaTotal);
      const remainingCount = targetIndex < visibleImageCount
        ? Math.max(mediaTotal - visibleImageCount, 0)
        : Math.max(mediaTotal - targetIndex - 1, 0);

      countElement.textContent = `+${remainingCount}`;
      countElement.closest('.yg-media-image-entry')?.setAttribute('aria-label', `${remainingCount} images remaining`);
    }

    getImageMediaIndex(gallery, slide, fallbackIndex) {
      const mediaItems = Array.from(gallery.querySelectorAll('.product-gallery__media:not([hidden])'));
      const slideIndex = mediaItems.indexOf(slide);

      if (slideIndex >= 0) {
        return slideIndex;
      }

      return Number.isFinite(Number(fallbackIndex)) ? Number(fallbackIndex) : -1;
    }

    pauseGalleryMedia() {
      this.querySelectorAll('video-media, model-media').forEach((media) => {
        media.pause?.();
      });

      this.querySelectorAll('video').forEach((video) => {
        video.pause?.();
      });
    }
  }

  if (!window.customElements.get('yg-gallery-button')) {
    window.customElements.define('yg-gallery-button', YGGalleryButton);
  }

  if (!window.customElements.get('yg-product-media-tabs')) {
    window.customElements.define('yg-product-media-tabs', YGProductMediaTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-main-article"] && !Shopify.designMode) return;
  try {
    
  class YGMainArticle extends HTMLElement {
    constructor() {
      super();
      this.toc = this.querySelector('[data-toc]');
      this.tocList = this.querySelector('[data-toc-list]');
      this.tocToggle = this.querySelector('[data-toc-toggle]');
      this.tocInner = this.querySelector('.yg-article__toc-inner');
      this.tocContent = this.querySelector('.yg-article__toc-content');
      this.tocProgress = this.querySelector('[data-toc-progress]');
      this.articleContent = document.getElementById('yg-article-content');
      this.items = [];
      this.TOP_OFFSET = 120;
      this.ticking = false;
      this.init();
    }

    init() {
      if (!this.toc || !this.articleContent) return;

      if (this.tocList) {
        this.generateToc();
      }

      if (!this.items.length) {
        this.toc.style.display = 'none';
        return;
      }

      this.setupScrollSpy();
      this.setupToggle();

      if (this.items[0]) {
        this.setActiveItem(this.items[0]);
      }
    }

    generateToc() {
      if (!this.articleContent || !this.tocList) return;

      const headings = Array.from(this.articleContent.querySelectorAll('h2, h3'));
      if (!headings.length) return;

      this.tocList.innerHTML = '';
      let h2Index = 0;
      let h3Index = 1;

      const self = this;

      headings.forEach(function(heading, index) {
        if (!heading.id) {
          heading.id = 'yg-heading-' + (index + 1);
        }

        const li = document.createElement('li');
        li.className = 'yg-article__toc-item';

        const link = document.createElement('a');
        link.className = 'yg-article__toc-link';
        link.href = '#' + heading.id;

        const isH2 = heading.tagName === 'H2';

        if (isH2) {
          h2Index++;
          h3Index = 1;
          link.innerHTML =
            '<span class="yg-article__toc-number">' +
            h2Index +
            '.</span><span>' +
            heading.textContent.trim() +
            '</span>';
        } else {
          link.innerHTML =
            '<span class="yg-article__toc-number yg-article__toc-number--h3">' +
            h2Index +
            '.' +
            h3Index +
            '</span><span>' +
            heading.textContent.trim() +
            '</span>';
          li.classList.add('yg-article__toc-item--h3');
          h3Index++;
        }

        link.addEventListener('click', function(event) {
          event.preventDefault();

          const rect = heading.getBoundingClientRect();
          const targetY = window.pageYOffset + rect.top - self.TOP_OFFSET;

          window.scrollTo({
            top: targetY,
            behavior: 'smooth'
          });

          self.setActiveItem(li);
          history.replaceState(null, '', '#' + heading.id);
        });

        li.appendChild(link);
        self.tocList.appendChild(li);
        self.items.push(li);
      });
    }

    setupScrollSpy() {
      if (!this.items.length) return;

      const self = this;
      const updateActiveByScroll = function() {
        let activeIndex = 0;
        let minDelta = Infinity;
        const headings = Array.from(self.articleContent.querySelectorAll('h2, h3'));

        headings.forEach(function(heading, index) {
          const rect = heading.getBoundingClientRect();
          const delta = Math.abs(rect.top - self.TOP_OFFSET);
          if (delta < minDelta) {
            minDelta = delta;
            activeIndex = index;
          }
        });

        if (self.items[activeIndex]) {
          self.setActiveItem(self.items[activeIndex]);
        }
      };

      const updateProgress = function() {
        if (!self.articleContent || !self.tocProgress) return;

        const contentRect = self.articleContent.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const contentTop = contentRect.top;
        const contentHeight = contentRect.height;

        const scrollableDistance = contentHeight - windowHeight;
        const scrolled = Math.max(0, -contentTop);
        const progress = Math.min(100, (scrolled / scrollableDistance) * 100);

        self.tocProgress.style.height = Math.max(28, (progress * 0.5)) + 'px';
      };

      window.addEventListener(
        'scroll',
        function() {
          if (!self.ticking) {
            window.requestAnimationFrame(function() {
              updateActiveByScroll();
              updateProgress();
              self.ticking = false;
            });
            self.ticking = true;
          }
        },
        { passive: true }
      );
    }

    setupToggle() {
      if (!this.tocToggle) return;

      const self = this;
      const isMobileLayout = function() {
        return window.innerWidth <= 1023;
      };

      const collapseToc = function() {
        self.toc.classList.add('is-collapsed');
        self.tocToggle.setAttribute('aria-expanded', 'false');
      };

      const expandToc = function() {
        self.toc.classList.remove('is-collapsed');
        self.tocToggle.setAttribute('aria-expanded', 'true');
      };

      if (isMobileLayout()) {
        collapseToc();
      }

      this.tocToggle.addEventListener('click', function() {
        const collapsed = self.toc.classList.toggle('is-collapsed');
        self.tocToggle.setAttribute('aria-expanded', (!collapsed).toString());
      });

      window.addEventListener('resize', function() {
        if (isMobileLayout()) {
          collapseToc();
        } else {
          expandToc();
        }
      });
    }

    setActiveItem(activeLi) {
      if (!activeLi) return;

      const self = this;
      this.items.forEach(function(item) {
        if (item === activeLi) {
          item.classList.add('is-active');
          item.classList.remove('is-inactive');
        } else {
          item.classList.remove('is-active');
          item.classList.add('is-inactive');
        }
      });

      const container = this.tocInner;
      if (!container) return;

      const containerRect = container.getBoundingClientRect();
      const itemRect = activeLi.getBoundingClientRect();

      const offsetTop = itemRect.top - containerRect.top;
      const padding = 4;
      const targetScroll = container.scrollTop + offsetTop - padding;

      container.scrollTo({
        top: targetScroll,
        behavior: 'smooth'
      });
    }
  }

  if (!window.customElements.get('yg-main-article')) {
    window.customElements.define('yg-main-article', YGMainArticle);
  }

  } catch(e) { console.error(e); }
})();
})();
